import React from 'react';
import PropTypes from 'prop-types';

import {productType} from 'propTypes/products';
import {Section} from 'components/layouts';
import {gettext, ngettext} from 'utils/text';

const DataColumn = ({data, field, title}) => {
    if (!data[field]) {
        return null;
    }

    if (field === 'estimated_duration' || field === 'actual_welding_time') {
        return [
            <div className="col-4 text-primary" key="title">{title}:</div>,
            <div className="col-8 text-primary" key="value">
                {data[field].toFixed(1).replace('.', ',')} {ngettext("hour", "hours", data[field])}
            </div>,
        ];
    }

    return [
        <div className="col-4 text-muted" key="title">{title}:</div>,
        <div className="col-8" key="value">{data[field]}</div>,
    ];
};

const ProductDetailsSection = ({product, userId}) => (
    <Section>
        <div className="details-card my-2" key={product.id}>
            <div className="row">
                <div className="col-lg-6">
                    <div className="row">
                        <DataColumn data={product} field="article_code" title={gettext("Code")} />
                        <DataColumn data={product} field="article_name" title={gettext("Name")} />
                        <DataColumn data={product.order} field="status_display" title={gettext("Status")} />
                        <DataColumn data={product.order} field="client_name" title={gettext("Client")} />
                        <DataColumn data={product.welder} field="name" title={gettext("Welder")} />
                        {/* Check if current user viewing the product is the welder assigned to it */}
                        {userId === product.welder.id && [
                            <DataColumn
                                key="est"
                                data={product}
                                field="estimated_duration"
                                title={gettext("Estimated time")}
                            />,
                            <DataColumn
                                key="act"
                                data={product}
                                field="actual_welding_time"
                                title={gettext("Actual time")}
                            />,
                        ]}
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="row">
                        <DataColumn data={product.order} field="info" title={gettext("Info")} />
                        <DataColumn data={product.order} field="width" title={gettext("Width")} />
                        <DataColumn data={product.order} field="fastening" title={gettext("Fastening")} />
                        <DataColumn data={product.order} field="extras" title={gettext("Extras")} />
                        <DataColumn data={product.order} field="transport" title={gettext("Transport")} />
                    </div>
                </div>
            </div>
        </div>
    </Section>
);

ProductDetailsSection.propTypes = {
    product: productType.isRequired,
    userId: PropTypes.number,
};

ProductDetailsSection.defaultProps = {
    userId: null,
};

export default ProductDetailsSection;



// WEBPACK FOOTER //
// ./src/components/ProductDetailsSection.js